export const SnipsActionTypes = {
  MAKE_SNIPS_REQUEST: "MAKE_SNIPS_REQUEST",
  MAKE_LIKES_REQUEST: "MAKE_LIKES_REQUEST",
  SET_SNIPS_DATA: "SET_SNIPS_DATA",
  SET_LIKES_DATA: "SET_LIKES_DATA",
  PUSH_SNIPS_DATA: "PUSH_SNIPS_DATA",
  REMOVE_SNIPS_DATA: "REMOVE_SNIPS_DATA",
  SET_SNIPS_ERROR: "SET_SNIPS_ERROR",
};
